<script lang="ts" setup>
import { LoaderOverlay } from '@shared/ui/loaders'

defineOptions({
  name: 'SkeletonChangeWeeklySchedule',
})

</script>

<template>
  <div class="change-schedule__box skeleton">
    <LoaderOverlay />
  </div>
</template>

<style scoped lang="scss" src="./SkeletonChangeWeeklySchedule.scss" />
